

import * as actionType from './actions/wareHouseActionType';

const initialState = {
  list: [],
  message: '',
  modalOpen: false,
  loading: false,
  isWareHouseEdit: false,
  isWareHouseList: true,
  isWareHouseCreate: false,
  isWareHouseView:false,
}

const wareHouseReducer = (state = initialState, action) => {
  let newState;
  switch (action.type) {
    case actionType.ADD_WAREHOUSE:
      return { ...state, loading: false, modalOpen: true, message: action.payload }
    // case actionType.UPDATE_STORE:
    //   return {...state,}
    //  newState = state - action.payload;
    case actionType.GET_WAREHOUSE_LIST_START:
      return { ...state, loading: true, modalOpen: false, message: "", }
    case actionType.GET_WAREHOUSE_LIST:
      return { ...state, loading: false, modalOpen: false, message: "", WareHouseDetails: action.payload }
    case actionType.GET_SELECTED_WAREHOUSE:
      return { ...state, loading: false, modalOpen: false, message: "", WareHouseDetail: action.payload }
    case actionType.GET_WAREHOUSE_LIST_ERROR:
      return { ...state, loading: false, modalOpen: true, message: action.payload, }
    case actionType.UPDATE_WAREHOUSE_DATA:
      return { ...state, loading: false, modalOpen: true, message: '', EditStore: action.payload }
    case actionType.LOAD_WAREHOUSE_DATA:
      return { ...state, loading: false, modalOpen: false, message: '', LoadStore: action.payload }
    case actionType.API_SUCCESS_WAREHOUSE:
      return { ...state, loading: false, modalOpen: false, message: '', statusCode: action.payload }
    case actionType.IS_WAREHOUSE_EDIT:
      return { ...state, isWareHouseEdit: action.payload, isWareHouseList: false }
    case actionType.IS_WAREHOUSE_CREATE:
      return { ...state, isWareHouseEdit: false, isWareHouseList: false, isWareHouseCreate: action.payload }
    case actionType.IS_WAREHOUSE_LIST:
      return { ...state, isWareHouseEdit: false, isWareHouseCreate: false,isWareHouseView:false, isWareHouseList: action.payload }
      case actionType.IS_WAREHOUSE_VIEW:
        return { ...state, isWareHouseView: action.payload, isWareHouseList: false}
   
    default:
      return state
  }
}

export default wareHouseReducer;